import script from "./SearchDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchDetails.vue?vue&type=script&setup=true&lang=js"

import "./SearchDetails.vue?vue&type=style&index=0&id=fcea17a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fcea17a4"]])

export default __exports__